import React, { useEffect, useRef, useState } from "react";
import { pdfjs, Document as PDFDocument, Page } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

import zoomin from "../../assets/icons/zoom_in.svg";
import zoomout from "../../assets/icons/zoom_out.svg";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
const PdfViewer = ({ file }) => {
  const [scale, setScale] = useState(1);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const containerRef = useRef();

  const adjustScaleToFit = () => {
    if (containerRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      const initialScale = containerWidth / 900; // Adjust this denominator based on your PDF size
      setScale(initialScale);
    }
  };

  useEffect(() => {
    adjustScaleToFit(); // Adjust the scale when component mounts
    const handleResize = () => {
      adjustScaleToFit(); // Re-adjust when window resizes
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const zoomIn = () => {
    setScale((prevScale) => Math.min(prevScale + 0.2, 5)); // Increment zoom by 0.2, max scale 5
  };

  const zoomOut = () => {
    setScale((prevScale) => Math.max(prevScale - 0.2, 0.2)); // Decrement zoom by 0.2, min scale 0.2
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    adjustScaleToFit(); // Adjust scale to fit the container after loading the document
  };

  return (
    <div className="relative flex flex-col h-full max-h-[92%]">
      <div className="flex flex-row items-center justify-center gap-4 pb-4">
        <button
          onClick={zoomOut}
          className="p-4 bg-shaiaBlue text-Grey-700 text-2xl w-12 h-12 flex items-center justify-center rounded-2"
        >
          <img src={zoomout} alt="zoom -" className="w-8" />
        </button>
        <button
          onClick={zoomIn}
          className="p-4 bg-shaiaBlue text-Grey-700 text-2xl w-12 h-12 flex items-center justify-center rounded-2"
        >
          <img src={zoomin} alt="zoom +" className="w-8" />
        </button>
      </div>
      <div className="flex-grow overflow-y-auto mb-5">
        <PDFDocument
          file={file}
          onLoadSuccess={onDocumentLoadSuccess}
          className="w-full flex justify-center"
        >
          <Page pageNumber={pageNumber} scale={scale} className="" />
        </PDFDocument>
      </div>
      <div className="flex justify-center items-center space-x-2 p-2 absolute bottom-[-50px] left-0 right-0 z-10 w-[98.7%]">
        {pageNumber > 1 && (
          <button
            className="bg-shaiaBlue text-DarkBlue-500 font-bold py-2 px-4 rounded"
            onClick={() => setPageNumber(pageNumber - 1)}
          >
            Anterior
          </button>
        )}
        {numPages && pageNumber < numPages && (
          <button
            className="bg-shaiaBlue text-DarkBlue-500 font-bold py-2 px-4 rounded"
            onClick={() => setPageNumber(pageNumber + 1)}
          >
            Siguiente
          </button>
        )}
      </div>
    </div>
  );
};

export default PdfViewer;
